import store from '@/store';

// requireAuth
// Checks if the user is authenticated, if not redirects them to the login screen.
export async function requireAuth(to, from, next) {
  try {
    await store.dispatch('auth/checkToken');
    next();
  } catch (err) {
    next({ path: '/login' });
  }
}

// loggedOut
// Checks if the user is currently logged out
export function loggedOut(to, from, next) {
  if (!store.state.auth.token) {
    next();
  } else {
    next({ path: '/' });
  }
}

/**
 * We want to loop through the permissions required and see if the user has it enabled
 */
export const privilegeCheck = (permissions, privileges) => {
  const availPermissions = permissions.filter(perm => !!privileges[perm] !== false);
  return availPermissions.length === permissions.length;
};
